<template>
  <card>
    <h4 slot="header" class="card-title">Edit Profile</h4>
    <form>
      <div class="row">

        <div class="col-md-6 form-group">
            <label class="label">{{$t('message.USER')}}</label>
            <input type="text" readonly :value="users.name"  class="form-control" >
        </div>

        <div class="col-md-6 form-group">
            <label class="label">{{$t('message.EMAIL')}}</label>
            <input type="email" readonly :value="users.email" class="form-control" >
        </div>

          <div class="col-md-6 form-group" style="margin-left:12px">
              <label class="label">{{$t('message.LANGUAGE')}}</label>
              <v-select :options="search_filter" :disabled="true" v-model="type" class="as-input-ht"></v-select>
          </div>
      </div>
        
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        search_filter:['English','Dansk'],
        type:'',
        users:{},
      }
    },
    methods: {
      updateProfile () {
      }
    },
    created()
    {
      this.users = JSON.parse(localStorage.getItem('users'));
      if(localStorage.getItem('lang') =='en')
      {
        this.type  ='English'
      }
      else
      {
        this.type ='Danish'
      }
    }
  }

</script>
<style>

</style>
